import { useState } from 'react'
import { CHAT_PRESETS } from '@anqi/shared'
import type { ChatPayload } from '../protocol-types'
import { seatStyle } from './Board'

/**
 * 聊天条。
 *
 * 三个人各在各家、**没有语音**，所以界面是他们唯一的交流通道。
 * 但手机键盘一弹出来就会把棋盘顶掉大半，所以分两层：
 *   预设短语 —— 常驻可见、一点即发，不弹键盘
 *   自由输入 —— 藏在一次点击后面
 */
interface ChatBarProps {
  messages: ChatPayload[]
  onSend(text: string, preset: boolean): void
}

export function ChatBar({ messages, onSend }: ChatBarProps) {
  const [typing, setTyping] = useState(false)
  const [draft, setDraft] = useState('')
  const recent = messages.slice(-4)

  return (
    <div className="space-y-2">
      {recent.length > 0 && (
        <div className="space-y-1 rounded-lg bg-slate-800/60 p-2 text-sm">
          {recent.map((m, i) => (
            <p key={`${m.at}-${i}`} className="leading-snug">
              <span className={`font-semibold ${seatStyle(m.seat).text}`}>
                {m.displayName}
              </span>
              <span className="text-slate-300">：{m.text}</span>
            </p>
          ))}
        </div>
      )}

      {/* 预设短语：常驻、一点即发。横向滚动，不占竖向空间 */}
      <div className="flex gap-2 overflow-x-auto pb-1">
        {CHAT_PRESETS.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onSend(p, true)}
            className="min-h-[44px] shrink-0 rounded-full border border-slate-600 px-4 text-sm"
          >
            {p}
          </button>
        ))}
        <button
          type="button"
          onClick={() => setTyping((v) => !v)}
          aria-label="自由输入"
          className="min-h-[44px] min-w-[44px] shrink-0 rounded-full border border-slate-600 px-3 text-sm"
        >
          ⌨
        </button>
      </div>

      {typing && (
        <form
          onSubmit={(e) => {
            e.preventDefault()
            const text = draft.trim()
            if (text === '') return
            onSend(text, false)
            setDraft('')
            setTyping(false)
          }}
          className="flex gap-2"
        >
          <input
            autoFocus
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            maxLength={200}
            placeholder="说点什么…"
            className="min-h-[44px] flex-1 rounded-lg bg-slate-800 px-3 text-sm outline-none ring-1 ring-slate-600 focus:ring-amber-400"
          />
          <button
            type="submit"
            className="min-h-[44px] rounded-lg bg-slate-100 px-4 text-sm font-bold text-slate-900"
          >
            发送
          </button>
        </form>
      )}
    </div>
  )
}
